import MetaPresenter from 'components/meta/containers/MetaPresenter';
import MetaH1 from 'components/meta/containers/MetaH1';
import Breadcrumbs from 'components/breadcrumbs/containers/Breadcrumbs';
import * as React from 'react';
import MenuBalance from 'moduleBase/modules/menu-balance/containers/MenuBalance';
import { Profile } from 'moduleBase/components/header/profile/Profile';
import { UserMenu } from 'moduleBase/types/Menu';
import { When } from 'react-if';
import Notifier from 'modules/chat/modules/notifier/containers/Notifier';
import app from 'srcJs/App';
import { ConfirmEmailNotifier } from 'moduleBase/components/header/confirm-email-notifier/ConfirmEmailNotifier';
import CartNotifier from 'moduleCartNotifier/containers/CartNotifier';
import { AlertInformationType } from 'moduleBase/components/alert-information/types/AlertInformationType';
import { AlertInformationList } from 'moduleBase/components/alert-information/AlertInformationList';
import { FC } from 'react';

type PropsType = {
  userMenu: UserMenu;
  alerts: AlertInformationType[];
};

const Header: FC<PropsType> = ({
  userMenu,
  alerts,
}) => {
  const user = app.getUser();

  return (
    <>
      <MetaPresenter />
      <div className="page-head">
        <div className="container container-lg-fluid">
          <div className="row align-items-center flex-nowrap">
            <div className="col min-w-0">
              <MetaH1 />
              <Breadcrumbs />
            </div>
            <div className="col-auto d-none d-xl-block">
              <Notifier />
            </div>
            <When condition={user.isCustomer()}>
              <div className="col-auto d-none d-xl-block">
                <CartNotifier />
              </div>
            </When>
            <MenuBalance />
            <Profile userMenu={userMenu} />
          </div>
        </div>
      </div>
      <div className="bg-white d-flex">
        <div className="container container-lg-fluid">
          <ConfirmEmailNotifier />
          <AlertInformationList alerts={alerts} />
        </div>
      </div>
    </>
  );
};
export default Header;
